import APP_CONFIG from "../services/_apiConfig/apiConfig";

const gtmId = APP_CONFIG?.GTM_ID;

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

export function initAnalytics() {
  if (!gtmId || window.__fincoGtmLoaded) return;
  window.__fincoGtmLoaded = true;

  ensureGtag();
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

export function trackSignUp(method = "email") {
  if (!gtmId) return;
  ensureGtag();
  window.gtag("event", "sign_up", { method });
}
